import store from '@/store'

function keys (agg) {
  return (agg || []).map(a => a.key)
}

// filterSuggestions is exposed by vuex_suggestions in ui-library and allows us to provide
// suggestions for the filters sidebar
export function setAggs (aggs) {
  store.commit('filterSuggestions/setMessage', keys(aggs.message))
  store.commit('filterSuggestions/setPolicySets', keys(aggs.policySets))
  store.commit('filterSuggestions/setGroups', keys(aggs.groups))
  store.commit('filterSuggestions/setDevices', keys(aggs.deviceId))
}